var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MenuLink } from '@reach/menu-button';
import defaultsDeep from 'lodash/defaultsDeep';
import { StyledMenu } from '../../../forms/MenuButton/style';
import { MediaLargerEqual } from '../../../utils/media-queries';
import Avatar from '../../Avatar';
import { SubmissionsBadge } from '../style';
import { Flexbox } from '../../../layout';
import { NotificationBadge } from '../../Badge';
import { StyledMenuButton, BorderMenuList, Bar, DownIcon, AvatarContainer } from './style';
var linkSettingsToAttrs = function (_a) {
    var newTab = _a.newTab, rest = __rest(_a, ["newTab"]);
    var attrs = {};
    if (newTab) {
        attrs.target = '_blank';
        attrs.rel = 'noopener noreferrer';
    }
    return defaultsDeep({}, rest, attrs);
};
var UserMenu = function (props) {
    var _a, _b, _c;
    var logClick = function (event) {
        props.logEvent(event, {
            eventPosition: 'navBar'
        });
    };
    var defaultLinkSettings = {
        profile: {
            children: 'Profile',
            newTab: props.newTabAll,
            href: "/profile/".concat(props.authUserId),
            onClick: function () {
                logClick('LINK_TO_PROFILE_CLICKED');
            }
        },
        submissions: {
            newTab: (_a = props.newTabAll) !== null && _a !== void 0 ? _a : true,
            children: (_jsxs(Flexbox, __assign({ justifyContent: "space-between", style: { width: 270 } }, { children: [_jsx("span", { children: "My Submissions" }), props.pendingSubmissions ? (_jsx(SubmissionsBadge, { children: props.pendingSubmissions })) : null] }))),
            href: '/submissions',
            onClick: function () { return logClick('LINK_TO_SUBMISSIONS_CLICKED'); }
        },
        contentStats: {
            children: 'Content Statistics',
            newTab: props.newTabAll,
            onClick: function () { return logClick('LINK_TO_STATS_CLICKED'); },
            href: '/stats/poster-views'
        },
        settings: {
            children: 'Settings',
            newTab: props.newTabAll,
            href: '/settings',
            onClick: function () { return logClick('LINK_TO_SETTINGS_CLICKED'); }
        },
        support: {
            children: 'Get help',
            newTab: (_b = props.newTabAll) !== null && _b !== void 0 ? _b : true,
            href: 'https://support.morressier.com',
            onClick: function () { return logClick('LINK_TO_HELP_CLICKED'); }
        },
        logout: {
            children: 'Logout',
            newTab: props.newTabAll,
            href: '/session/logout',
            onClick: function () { return logClick('LINK_TO_LOGOUT_CLICKED'); }
        }
    };
    var linkSettings = defaultsDeep(defaultsDeep(props.linkSettings, defaultLinkSettings), linkSettingsToAttrs);
    var avatar = (_jsx(Avatar, { size: "small", fullName: props.fullName, src: props.pictureUrl }));
    return (_jsx(_Fragment, { children: _jsxs(StyledMenu, { children: [_jsxs(StyledMenuButton, __assign({ onClick: props.onMenuButtonClick }, { children: [_jsx(DownIcon, { color: (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.topbarMenuIconColor }), !!props.showUserFullName && (_jsx(MediaLargerEqual, __assign({ breakpoint: "xlarge" }, { children: _jsx(AvatarContainer, __assign({ textAs: "div", withMenuIcon: true }, { children: props.fullName })) }))), avatar, props.pendingSubmissions > 0 ? (_jsx(NotificationBadge, __assign({ "aria-label": "Pending Submissions" }, { children: props.pendingSubmissions }))) : null] })), _jsxs(BorderMenuList, { children: [_jsx(MenuLink, __assign({}, linkSettingsToAttrs(linkSettings.profile))), _jsx(MenuLink, __assign({}, linkSettingsToAttrs(linkSettings.contentStats))), _jsx(MenuLink, __assign({}, linkSettingsToAttrs(linkSettings.settings))), _jsx(Bar, {}), _jsx(MenuLink, __assign({}, linkSettingsToAttrs(linkSettings.submissions))), _jsx(Bar, {}), _jsx(MenuLink, __assign({}, linkSettingsToAttrs(linkSettings.support))), _jsx(MenuLink, __assign({}, linkSettingsToAttrs(linkSettings.logout)))] })] }) }));
};
export default UserMenu;
//# sourceMappingURL=index.js.map